import { t, type MessageKey } from '@aquabox/shared';
import type { AssignReason } from '../api/types';

/**
 * Atama gerekçesinin kanıt metni (sipariş detayı). API `assignSource` alanını okunur hâle getirir:
 *  - PANEL_LABEL: ham etiket GÖSTERİLMEZ (Abant'ta çalışan numarası olabilir). Araç varsa
 *    "Panel etiketi → <plaka>" (plaka `vehicle.plate`'ten), yoksa yalnız "Panel etiketi".
 *  - HISTORY: `hist2:<s|m>:<anahtar>:<plaka>:<n>/<m>` → "geçmiş: <anahtar> · <plaka> · n/m".
 *  - UNMATCHED: neden kodu → `assign.unmatched.<KOD>`.
 * Diğer gerekçelerde kanıt (kural kimliği, bölge id) kullanıcıya gösterilmez → null.
 * Kanıt biçimi bozuksa null (fail-closed: yanlış metin göstermektense hiçbir şey).
 */
export function assignEvidenceText(
  reason: AssignReason | null | undefined,
  source: string | null | undefined,
  vehiclePlate?: string | null,
): string | null {
  if (!reason) return null;
  if (reason === 'PANEL_LABEL') {
    return vehiclePlate
      ? t('assign.evidence.labelPlate', { plate: vehiclePlate })
      : t('assign.evidence.labelOnly');
  }
  if (!source) return null;
  if (reason === 'UNMATCHED') return t(`assign.unmatched.${source}` as MessageKey);
  if (reason === 'HISTORY') {
    const parts = source.split(':');
    if (parts.length !== 5 || parts[0] !== 'hist2') return null;
    return t('assign.evidence.history', {
      place: parts[2] ?? '',
      plate: parts[3] ?? '',
      ratio: parts[4] ?? '',
    });
  }
  return null;
}
